import Vue from 'vue'
import axios from 'axios'
import VueRouter from 'vue-router'
import store from './store/store'

import Home from './views/Home'
import Conversation from './views/Conversation.vue'
import ErrorPage from './views/Error'
import ArchivedConversation from './views/ArchivedConversation'
import Settings from './views/Settings'
import Login from './views/Login'
import Dashboard from './views/Dashboard'
import HourlyReport from './views/HourlyReport'
import DailyReport from './views/DailyReport'
import MonthlyReport from './views/MonthlyReport'
import PReport from './views/PReport'
import MessageTemplate from './views/MessageTemplate'
import MessageTemplateCategory from './views/MessageTemplateCategory'
import AutoMessage from './views/AutoMessage'
import LineAudience from './views/LineAudience'
import ServerSettings from './views/ServerSettings'
import AiDocuments from './views/AiDocuments'
import Tag from './views/Tag'

// Window Popup
import CoordinationFrom from './components/caseCoordination/Form.vue'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      children: [
        {
          path: 'conversations',
          name: 'conversations',
          component: Conversation,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'conversations/:id',
          name: 'conversations',
          component: Conversation,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'archived-conversations',
          name: 'archived conversations',
          component: ArchivedConversation,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'settings',
          name: 'settings',
          component: Settings,
          children: [
            {
              path: 'message-template',
              name: 'message-template',
              component: MessageTemplate,
              meta: {
                requiresAuth: true
              }
            },
            {
              path: 'message-template-category',
              name: 'message-template-category',
              component: MessageTemplateCategory,
              meta: {
                requiresAuth: true
              }
            },
            {
              path: 'tag',
              name: 'tag',
              component: Tag,
              meta: {
                requiresAuth: true
              }
            },
            {
              path: 'auto-message',
              name: 'auto-message',
              component: AutoMessage,
              meta: {
                requiresAuth: true
              }
            },
            {
              path: 'server-settings',
              name: 'server-settings',
              component: ServerSettings,
              meta: {
                requiresAuth: true
              }
            },
            {
              path: 'line-audience',
              name: 'line-audience',
              component: LineAudience,
              meta: {
                requiresAuth: true
              }
            },
            {
              path: 'ai-documents',
              name: 'ai-documents',
              component: AiDocuments,
              meta: {
                requiresAuth: true
              }
            }
          ]
        }
      ]
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      beforeEnter: (to, from, next) => {
        const { admin } = store.state.admin
        if (admin) {
          next({ path: '/' })
        }
        next()
      }
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      component: Dashboard,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/p-report',
      name: 'p-report',
      component: PReport,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/hourly-report',
      name: 'hourly-report',
      component: HourlyReport,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/daily-report',
      name: 'daily-report',
      component: DailyReport,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/monthly-report',
      name: 'monthly-report',
      component: MonthlyReport,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/error',
      name: 'error',
      component: ErrorPage
    },
    {
      path: '/case-coordination',
      name: 'Case Coordination',
      component: CoordinationFrom,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/about',
      name: 'about',
      component: () => import('./views/About.vue'),
      meta: {
        requiresAuth: true
      }
    }
  ]
})

router.beforeEach(async (to, from, next) => {
  // get state from store
  const { admin } = store.state.admin

  // เช็คว่า route ไหนต้องการ requiresAuth บ้าง และถ้าไม่มีการล็อคอินอยู่ให้เด้งไปหน้า Login
  if (to.meta.requiresAuth && (!admin)) {
    // console.log('DEBUG', '1')
    if (to) {
      // console.log('DEBUG', '2')
      localStorage.setItem('redirect', to.path)
      // console.log('DEBUG', to.path)
    }

    store.commit('general/SET_REDIRECT_URL', to ? to.fullPath : '')
    next({ path: '/login' })
  } else if (to.meta.requiresAuth && admin) {
    let adminDB = null
    try {
      const { data } = await axios.get('admins/' + admin.id)
      adminDB = data.admin
    } catch (err) {
      const status = err && err.response ? err.response.status : null
      // ไม่มีแอดมินคนนี้ใน DB (ถูกลบ / session ค้างข้าม DB เช่นสลับ local dev ↔ prod-data)
      // เดิม error หลุดออกไป navigation ค้าง = จอขาว — ให้ logout ไปหน้า login แทน
      if (status === 400 || status === 404) {
        store.dispatch('admin/LOGOUT').then(() => { next({ path: '/login' }) })
        return
      }
      // เน็ต / server ล่ม: ไม่เตะออก ให้เข้าหน้าได้ตามเดิม
      next()
      return
    }

    // ถ้า admin status ถูกปลด ให้ logout ออก
    if (!adminDB || adminDB.status === 0) {
      store.dispatch('admin/LOGOUT').then(res => { next({ path: '/login' }) })
    }
    next()
  } else {
    // console.log('DEBUG', '3')
    // ถ้าไม่มีการต้องการ requiresAuth ก็ให้ผ่านได้เลย
    next()
  }
})

export default router
